import { render, staticRenderFns } from "./ShopElement.vue?vue&type=template&id=5d7a57cd&scoped=true&"
import script from "./ShopElement.vue?vue&type=script&lang=js&"
export * from "./ShopElement.vue?vue&type=script&lang=js&"
import style0 from "./ShopElement.vue?vue&type=style&index=0&id=5d7a57cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a57cd",
  null
  
)

export default component.exports